import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { projects } from "../constants/projects";
import { useNavigate } from "react-router-dom";

function TopProjects() {
  const navigate = useNavigate();
  return (
    <Container>
      <div
        className="position-relative my-5 py-5 text-center"
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <h1 className="bolder fg-heading text-white mb-0">
          CAREER <span className="bolder primary-color">HIGHLIGHTS</span>
        </h1>
        <h1 className="bolder bg-title">PORTFOLIO</h1>
      </div>
      <h3
        className="bolder text-center text-white mb-5"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="200"
      >
        Projects
      </h3>
      <Row>
        {projects.slice(0, 3).map((project, index) => (
          <Col
            md="12"
            lg="4"
            key={index}
            data-aos="zoom-in"
            data-aos-duration="1000"
            data-aos-delay={index * 200}
          >
            <div className="p-5">
              <div className="d-flex align-items-center justify-content-center position-relative">
                <div
                  style={{ width: "100%", height: 200 }}
                  role="button"
                  onClick={() => navigate(`/project/${project.slug}`)}
                >
                  <div className="project-img-before">
                    <img
                      style={{ width: "100%", height: 200, objectFit: "cover" }}
                      src={project.image}
                      alt={project.name}
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex flex-column justify-content-center mt-5">
                <div
                  role="button"
                  onClick={() => navigate(`/project/${project.slug}`)}
                  className="d-flex align-items-center mb-4"
                >
                  <h3 className="text-white bolder me-2">{project.name}</h3>
                  <img
                    src="/assets/external-link-active.svg"
                    alt="external-link"
                    className="mb-2"
                  />
                </div>
                <div className="text-white-50" style={{ height: 120 }}>
                  {project.description}
                </div>
              </div>
            </div>
          </Col>
        ))}
      </Row>
      <div
        className="my-5 d-flex justify-content-center"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="600"
      >
        <button
          onClick={() => navigate("/projects")}
          type="submit"
          className="ms-2 button"
        >
          <span className="button-text">View All</span>
          <img src="/assets/arrow.svg" alt="send" className="button-icon p-2" />
        </button>
      </div>
    </Container>
  );
}

export default TopProjects;
